module.exports = __webpack_public_path__ + "static/media/surge.32abfb1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/surge.png
// module id = 199
// module chunks = 0